import React from 'react';
import MainLayout from '../../layouts/MainLayout';

const WelcomePage: React.FC = () => {
  return (
    <MainLayout>
      <div>Добро пожаловать</div>
    </MainLayout>
  );
};

export default WelcomePage;
